const ModernLayoutIcon = ({
    size = 98,
    primaryColor = "#353535",
    secondaryColor = "#E0E0E0",
}: {
    size?: number | string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
}) => {
    return (
        <svg width={size} height={"auto"} viewBox="0 0 98 109" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="12" y="13" width="17" height="17" rx="1" fill={primaryColor} />
            <rect x="33" y="13" width="53" height="17" rx="1" fill={secondaryColor} />
            <line x1="12" y1="37.7915" x2="86" y2="37.7915" stroke={primaryColor} stroke-width="0.416902" />
            <rect x="12" y="46" width="17" height="17" rx="1" fill={primaryColor} />
            <rect x="33" y="46" width="53" height="17" rx="1" fill={secondaryColor} />
            <line x1="12" y1="70.7915" x2="86" y2="70.7915" stroke={primaryColor} stroke-width="0.416902" />
            <rect x="12" y="79" width="17" height="17" rx="1" fill={primaryColor} />
            <rect x="33" y="79" width="53" height="17" rx="1" fill={secondaryColor} />
        </svg>
    );
};

export default ModernLayoutIcon;
